import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: true,
            showVariant: true,
            showPackage: false,
            showStartDateWithTime: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: 'RO_TRAVEL',
            fallbackAssistanceEmailsKey: 'RO_TRAVEL',
        },
        showLinkedCards: false,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
